<template>
  <v-app id="huovPrijsUitleg">

    <defNavBar title="Ares - Rental contract price explanation" :home="true"/>

    <v-main>       
      <v-container fluid>
        <v-row cols="12">
          <v-col cols="6">  
           <span class="mx-5 headline">Guest</span>
          </v-col>
          <v-col cols="6">   
           <span class="mx-5 headline">Host</span>
          </v-col>  
        </v-row>
        <v-row cols="12">
          <v-col cols="6">  
           <v-textarea class="mx-5" v-model="huov.huov_verk_uitleg" rows=25></v-textarea>
          </v-col>
          <v-col cols="6">   
            <v-textarea class="mx-5" v-model="huov.huov_ink_uitleg" rows=25></v-textarea>
          </v-col>  
        </v-row>
      </v-container>
    </v-main>
  </v-app>
</template>

<script>
  import defNavBar from '@/components/ui/navbars/navbar.vue';
 export default {
  components: {
    defNavBar
  },
  props: ['huov_encrid'],
  data() {
    return {
      huov: {
      }
    }
    
  },
  mounted() {
    this.$axios
      .post("ares/json/ares/huov/getHuovUitleg.p", {
        header: {
          token: this.$session.get("ARES"),
          clientSessionId: this.$session.id(),
          request: "getHuovUitleg"
        },
        getHuovUitleg: {
          huov_encrid: this.huov_encrid
       }
      })
      .then(res => {
        if (res.data.error) {
          console.log(res.data.error);
        } else {
           this.huov = res.data.getHuovUitleg;
           document.title = 'Expl. ' + res.data.getHuovUitleg.huov_code;
        }
      });

  }
};

</script> 
